// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { Card, LgPadding } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// eslint-disable-next-line import/no-deprecated
import { fetchServiceAvailability } from '~shared/actions/auth';
import { getOnboardingVerificationRequired } from '~shared/features/onboarding/selectors/getOnboardingVerification';
import { areCookiesDisabled } from '~shared/helpers/getDeviceID';
import getAuth from '~shared/selectors/auth/getAuth';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { OnboardingContactVerification } from './OnboardingContactVerification';
import { OnboardingGeoUncovered } from './OnboardingGeoUncovered';
import { ServiceAreaForm } from './ServiceAreaForm';
import { SignupForm } from './SignupForm';
import { PageBackground, SingleColumnContentWrapper } from '~web/components/Page';
import { CookieError } from '~web/features/auth/components/CookieError';

export const SignupPage = () => {
  const dispatch = useDispatchShared();
  const { navigate } = useNavigation();
  const { authorized, serviceAvailabilityChecked, serviceAvailable } = useSelectorShared(getAuth);
  const verificationRequired = useSelectorShared(getOnboardingVerificationRequired) ?? false;
  const { isFertDeliverySignup } = useSelectorShared((state) => state.uiOnboarding);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const zip = searchParams.get('zip') ?? '';

  useEffect(() => {
    if (zip) {
      // eslint-disable-next-line import/no-deprecated
      dispatch(fetchServiceAvailability(zip));
    }
  }, [dispatch, zip]);

  useEffect(() => {
    if (authorized && !verificationRequired) {
      navigate('RouteAppTabNavigator', { screen: 'RouteTabHomescreen' });
    }
  }, [authorized, navigate, verificationRequired]);

  const cookiesDisabled = areCookiesDisabled();

  let body;
  let title;

  if (serviceAvailabilityChecked || authorized) {
    if (isFertDeliverySignup !== null || serviceAvailable || authorized) {
      if (verificationRequired) {
        title = 'Verify account';
        body = <OnboardingContactVerification />;
      } else {
        // Available for user to sign up
        title = 'Create account';
        body = <SignupForm />;
      }
    } else {
      // Not available in the user's area
      body = <OnboardingGeoUncovered zip={zip} />;
    }
  } else {
    // User hasn't entered their zip yet
    title = 'Sign up';
    body = <ServiceAreaForm disabled={cookiesDisabled} />;
  }

  return (
    <PageBackground>
      <SingleColumnContentWrapper>
        {cookiesDisabled ? <CookieError /> : null}
        <Card title={title}>
          <LgPadding topPadding={SPACING.STATIC.NONE}>{body}</LgPadding>
        </Card>
      </SingleColumnContentWrapper>
    </PageBackground>
  );
};
